import { getAllSpecializationAreasReq } from "../../../../redux/guest-slices/common.slice"
import SpecializationAreas from "../../../../components/ui/SpecializationAreas"
import InputField1 from "../../../../components/ui/InputField1"
import FileInput from "../../../../components/ui/FileInput"
import { Grid2 as Grid, Typography } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { Fragment, useEffect, useState } from "react"


function Holistic({ errors, files, onChangFun }) {
  const dispatch = useDispatch()
  const [areas, setAreas] = useState([])
  const { specialist } = useSelector(state => state.specialistSlice)

  const handleGetAreas = (filters) => {
    dispatch(getAllSpecializationAreasReq({
      limit: filters?.limit || 10,
      id: "67d90056c2c4d5ab747f8b3d"
    })
    ).unwrap().then((data) => {
      setAreas(data)
    }).catch(() => { })
  }

  useEffect(() => {
    handleGetAreas()

    // eslint-disable-next-line
  }, [])

  return (
    <Fragment>
      <Grid size={12}>
        <InputField1
          type="text"
          errors={errors}
          name="trainingBackground"
          label="Training in Holistic Practices *"
          placeholder="Enter Training in Holistic Practices"
          errText="Please enter training in holistic practices"
          defaultValue={specialist?.profile?.trainingBackground || ""}
        />
      </Grid>

      <Grid size={12} sx={{ "> div + div:has(div)": { mt: 2 } }}>
        <FileInput
          files={files}
          errors={errors}
          name="specializationCertificate"
          label="Qualification in Holistic Practices *"
          errText="Please upload qualification in holistic practices"
          placeholderText="Upload Qualification in Holistic Practices"
          defaultValue={specialist?.profile?.specializationCertificate || []}
        />
      </Grid>

      <Grid size={12}>
        <InputField1
          type="textarea"
          errors={errors}
          name="holisticPractices"
          label="Holistic Practices *"
          errText="Please enter holistic practices"
          defaultValue={specialist?.profile?.holisticPractices || ""}
          placeholder="Describe the holistic health practices you offer, such as nutrition and diet, mind-body connection, natural remedies, etc"
        />
      </Grid>

      <Grid size={12}>
        <InputField1
          type="textarea"
          errors={errors}
          label="Specialization Areas *"
          name="specializationAreaDescription"
          errText="Please enter specialization areas"
          defaultValue={specialist?.profile?.specializationAreaDescription || ""}
          placeholder="List your areas of specialization, such as stress management, fitness, spiritual health, etc"
        />
      </Grid>

      <Grid size={12}>
        <SpecializationAreas
          areas={areas}
          errors={errors}
          onChangFun={onChangFun}
          label="Specialization Areas *"
        />
      </Grid>

      <Typography
        color="#7A8A9E"
        fontWeight="500"
        fontStyle="italic"
      >Guide clients towards holistic health and wellness. Share your practices and areas of expertise
      </Typography>
    </Fragment>
  )
}

export default Holistic